// Generated types for ProductRequirementsAnalysisTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI } from '../../shared/types/neonode';
import { TaskReadAPI, TaskWriteAPI } from '../../tasks/types/task';
import { NeoNodeReadAPISchema } from '../../shared/types/neonode';
import { TaskReadAPISchemaObject, TaskWriteAPISchemaObject } from '../../tasks/types/task';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ProductRequirementsAnalysisTaskReadAPI extends TaskReadAPI {
}

export interface ProductRequirementsAnalysisTaskWriteAPI extends TaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ProductRequirementsAnalysisTaskReadAPISchema: z.ZodType<ProductRequirementsAnalysisTaskReadAPI> = TaskReadAPISchemaObject.extend({}).passthrough();

export const ProductRequirementsAnalysisTaskWriteAPISchema: z.ZodType<ProductRequirementsAnalysisTaskWriteAPI> = TaskWriteAPISchemaObject.extend({}).passthrough();
